import template from './branches.html';
import tr from '../../lib/default-translator.js';

class AdminBranchesViewModel
{
	constructor(page)
	{
		this.page = page;
	}

	show_branches_help()
	{
		Grape.dialog.open('BranchesHelp', { employee_id: this.page.bindings.id });
	}
}

class AdminBranchesPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminBranchesViewModel(this);

		document.title = tr('Manage Branches');
		window.current_page_title(tr('Add/Edit Branches'));
	}
}

export default {
	route: '[/]admin/branches',
	page_class: AdminBranchesPage,
	template: template,
	template_filename: 'translation/branches'
};
